import { render, staticRenderFns } from "./AdBannerPartial.vue?vue&type=template&id=83adcffe&scoped=true&"
import script from "./AdBannerPartial.vue?vue&type=script&lang=js&"
export * from "./AdBannerPartial.vue?vue&type=script&lang=js&"
import style0 from "./AdBannerPartial.vue?vue&type=style&index=0&id=83adcffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83adcffe",
  null
  
)

export default component.exports